module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"group":"Gruppe","products":"Artikel","productId":"Artikelnr.","productTitle":"Artikelbezeichnung","rank":"Rang","salesDefaultUnit":"Verkauf GE","search":"Suche","kind":"Sorte"},"en":{"group":"Group","products":"Products","productId":"Product ID","productTitle":"Product","rank":"Rank","salesDefaultUnit":"Sales default unit","search":"Search","kind":"Kind"}}')
  delete Component.options._Ctor
}
